import { render, staticRenderFns } from "./contractDetails.vue?vue&type=template&id=0f0e0be8"
import script from "./contractDetails.vue?vue&type=script&lang=js"
export * from "./contractDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports